import React from 'react';
import styles from '../../styles/components/cards/productCard.module.css';

function ProductCard({ product, onDelete, onEdit }) {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
  const fullImageUrl = `${BASE_URL}${product.image_url}`;

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const getStockBadge = (count) => {
    // Se o produto não estiver ativo, mostramos o status de inativo primeiro
    if (product.is_active === false) {
      return <span className={styles.inactiveBadge} style={{ backgroundColor: '#718096', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' }}>Inativo / Arquivado</span>;
    }
    
    if (count <= 0) return <span className={styles.outOfStock}>Esgotado</span>;
    if (count <= 5) return <span className={styles.lowStock}>Baixo: {count}</span>;
    return <span className={styles.inStock}>Estoque: {count}</span>;
  };

  return (
    /* Adicionada uma classe condicional para esmaecer produtos inativos */
    <div className={`${styles.productCard} ${product.is_active === false ? styles.cardDisabled : ''}`} 
         style={product.is_active === false ? { opacity: 0.6, filter: 'grayscale(0.5)' } : {}}>
      
      <div className={styles.productMain}>
        <div className={styles.imageContainer}>
          {product.featured && <div className={styles.featuredLabel}>DESTAQUE</div>}
          
          {/* Badge de Inativo sobre a imagem */}
          {product.is_active === false && (
            <div style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#e53e3e', color: 'white', padding: '2px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: 'bold', zIndex: 2 }}>
              OFFLINE
            </div>
          )}
          
          <img src={fullImageUrl} alt={product.name} />
        </div>
        
        <div className={styles.nameBlock}>
          <h3 className={styles.productName}>
            {product.name} {product.is_active === false && '(Inativo)'}
          </h3>
          <span className={styles.productID}>ID: #{product.id.toString().padStart(4, '0')}</span>
        </div>
      </div>

      <div className={styles.productMetrics}>
        <div className={styles.metricGroup}>
          <span className={styles.metricLabel}>Preço</span>
          <span className={styles.metricValue}>{formatCurrency(product.price)}</span>
        </div>

        <div className={styles.metricGroup}>
          <span className={styles.metricLabel}>Opções</span>
          <span className={styles.metricValueEmerald}>
            {product.options && product.options.trim() !== ""
              ? product.options
              : "Único"}
          </span>
        </div>

        <div className={styles.metricGroup}>
          <span className={styles.metricLabel}>Status</span>
          <div className={styles.statusWrapper}>
            {getStockBadge(product.stock)}
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.editBtn} onClick={() => onEdit(product)} title="Editar">
            ✏️
          </button>
          
          {/* Só mostramos o botão de excluir se o produto ainda estiver ativo */}
          {product.is_active !== false && (
            <button className={styles.deleteBtn} onClick={() => onDelete(product.id)} title="Desativar">
              🗑️
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;